import React, { useState, useMemo, lazy, Suspense } from "react";
import L from "leaflet";
import ParentPanel from "../panel/ParentPanel";
import "leaflet/dist/leaflet.css";
import "../styles/Transport.css";

const TransportMap = lazy(() => import("../components/TransportMap"));

const Transport = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [searchBus, setSearchBus] = useState("");

  const buses = [
    {
      number: "City Express 101",
      route: "Central Station → Green Park → Riverside → Downtown",
      driver: "Mr. Ramesh Kumar",
      timing: "6:30 AM - 2:30 PM",
      distance: "30 km",
      stopages: [
        { name: "Central Station", arrival: "6:30 AM", departure: "6:35 AM", lat: 28.7041, lng: 77.1025 },
        { name: "Green Park", arrival: "6:50 AM", departure: "6:55 AM", lat: 28.7100, lng: 77.1080 },
        { name: "Riverside", arrival: "7:10 AM", departure: "7:15 AM", lat: 28.7180, lng: 77.1150 },
        { name: "Downtown", arrival: "7:30 AM", departure: "7:35 AM", lat: 28.7250, lng: 77.1200 },
      ],
      returnTrip: [
        { arrival: "1:30 PM", departure: "1:35 PM" },
        { arrival: "1:50 PM", departure: "1:55 PM" },
        { arrival: "2:10 PM", departure: "2:15 PM" },
        { arrival: "2:30 PM", departure: "2:35 PM" },
      ],
    },
    {
      number: "MetroLink 205",
      route: "Airport → Tech Park → City Mall → Old Town",
      driver: "Ms. Sunita Verma",
      timing: "7:00 AM - 3:00 PM",
      distance: "28 km",
      stopages: [
        { name: "Airport", arrival: "7:00 AM", departure: "7:05 AM", lat: 28.7100, lng: 77.1000 },
        { name: "Tech Park", arrival: "7:20 AM", departure: "7:25 AM", lat: 28.7150, lng: 77.1080 },
        { name: "City Mall", arrival: "7:40 AM", departure: "7:45 AM", lat: 28.7220, lng: 77.1150 },
        { name: "Old Town", arrival: "8:00 AM", departure: "8:05 AM", lat: 28.7300, lng: 77.1200 },
      ],
      returnTrip: [
        { arrival: "2:00 PM", departure: "2:05 PM" },
        { arrival: "2:20 PM", departure: "2:25 PM" },
        { arrival: "2:40 PM", departure: "2:45 PM" },
        { arrival: "3:00 PM", departure: "3:05 PM" },
      ],
    },
  ];

  const filteredBuses = useMemo(
    () =>
      buses.filter((bus) =>
        bus.number.toLowerCase().includes(searchBus.toLowerCase())
      ),
    [searchBus]
  );

  const busIcon = new L.DivIcon({
    html: "🚍",
    className: "custom-bus-icon",
    iconSize: [30, 30],
    iconAnchor: [15, 15],
  });

  return (
    <>
      <ParentPanel onToggle={setIsSidebarCollapsed} />

      <div className={`transport-content ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <h1>Transport Information</h1>

        <div className="bus-search">
          <input
            type="text"
            placeholder="Search by Bus Number..."
            value={searchBus}
            onChange={(e) => setSearchBus(e.target.value)}
          />
        </div>

        {filteredBuses.map((bus, index) => (
          <div key={index} className="bus-card split-card">

            {/* MAP */}
            <div className="bus-map">
              <Suspense fallback={<div>Loading map...</div>}>
                <TransportMap bus={bus} busIcon={busIcon} />
              </Suspense>
            </div>

            {/* DETAILS */}
            <div className="bus-details">
              <table>
                <caption>{bus.number} - {bus.route}</caption>
                <tbody>
                  <tr>
                    <th>Driver</th>
                    <td>{bus.driver}</td>
                  </tr>
                  <tr>
                    <th>Timing</th>
                    <td>{bus.timing}</td>
                  </tr>
                  <tr>
                    <th>Distance</th>
                    <td>{bus.distance}</td>
                  </tr>

                  <tr>
                    <th colSpan={5}>Stopages & Times</th>
                  </tr>

                  <tr>
                    <th>Stop</th>
                    <th>Arrival</th>
                    <th>Departure</th>
                    <th>Return Arrival</th>
                    <th>Return Departure</th>
                  </tr>

                  {bus.stopages.map((stop, i) => (
                    <tr key={i}>
                      <td>{stop.name}</td>
                      <td>{stop.arrival}</td>
                      <td>{stop.departure}</td>
                      <td>{bus.returnTrip[i]?.arrival || "-"}</td>
                      <td>{bus.returnTrip[i]?.departure || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

          </div>
        ))}

        {filteredBuses.length === 0 && <p>No buses found.</p>}
      </div>
    </>
  );
};

export default Transport;